import { createContext, type ReactNode, useContext } from 'react'

export type ActionMenuContextType<Data extends Record<string, unknown> = Record<string, unknown>> =
  {
    row: Data
    closeMenu: () => void
  }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ActionMenuContext = createContext<ActionMenuContextType<any> | undefined>(undefined)

export const useActionMenuContext = <
  Data extends Record<string, unknown>
>(): ActionMenuContextType<Data> => {
  const context = useContext(ActionMenuContext)
  if (context === undefined) {
    throw new Error('useActionMenuContext must be used within an ActionMenuContextProvider')
  }
  return context
}

type ActionMenuContextProviderProps<Data extends Record<string, unknown>> = {
  children: ReactNode
  value: ActionMenuContextType<Data>
}

export const ActionMenuContextProvider = <Data extends Record<string, unknown>>({
  children,
  value
}: ActionMenuContextProviderProps<Data>) => {
  return <ActionMenuContext.Provider value={value}>{children}</ActionMenuContext.Provider>
}
